export const environment = {
  production: false,
  contentBaseUrl: 'https://cdn.llucllull.dev/content/v1',
  assetsBaseUrl: 'https://cdn.llucllull.dev/assets/v1',
};